<template>
  <div>
    <CrossWalkStatistics />
    <br>
    <CrossWalkChart />
    <br>
    <CrossWalkTable />
  </div>
</template>

<script>
import CrossWalkStatistics from '@/views/crosswalk/detail/CrossWalkStatistics.vue'
import CrossWalkTable from '@/views/crosswalk/detail/CrossWalkTable.vue'
import CrossWalkChart from '@/views/crosswalk/detail/CrossWalkChart.vue'
// import axios from '@axios'
export default {
  components: {
    CrossWalkStatistics,
    CrossWalkTable,
    CrossWalkChart,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
